import { VERIFY_ROUTE } from "./type"

export const verifyRoute = (route, callback) => {
    return async dispatch => {
        await dispatch({ type: VERIFY_ROUTE, payload: route })
        if (callback) {
            callback()
        }
    }
}